var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessApproval(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4978_11409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66665 3.50033V3.03366C4.66665 2.00116 4.66665 1.16699 6.53331 1.16699H7.46665C9.33331 1.16699 9.33331 2.00116 9.33331 3.03366V3.50033M4.66665 12.8337H9.33331C11.6783 12.8337 12.0983 11.8945 12.2208 10.7512L12.6583 6.08449C12.8158 4.66116 12.4075 3.50033 9.91665 3.50033H4.08331C1.59248 3.50033 1.18415 4.66116 1.34165 6.08449L1.77915 10.7512C1.90165 11.8945 2.32165 12.8337 4.66665 12.8337Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16665 8.17866V7.58366C8.16665 7.00033 8.16665 7.00033 7.58332 7.00033H6.41665C5.83332 7.00033 5.83332 7.00033 5.83332 7.58366V8.18449M8.16665 8.17866C8.16665 8.81449 8.16082 9.33366 6.99999 9.33366C5.84499 9.33366 5.83332 8.82033 5.83332 8.18449M8.16665 8.17866C9.77911 7.97792 11.3144 7.37183 12.6292 6.41699M5.83332 8.18449C4.32249 8.01533 2.84082 7.47283 1.52832 6.57449",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4978_11409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessApproval);
export default __webpack_public_path__ + "static/media/business-approval.7436fbbff6e759396b161fc2bcce0e67.svg";
export { ForwardRef as ReactComponent };